import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import {
  ICustomerConfiguration,
  ICustomerConfigurationInput,
} from "@/interfaces/customer-configuration.interface";
import { IFilter } from "@/types/filter.types";
import { FreightOverheadType } from "@/types/customer-configuration.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class CustomerConfigurationService {
  private baseUrl = "api/v1/customersettings";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<ICustomerConfiguration>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const response = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return response;
  }

  async filter(
    filter: IFilter<ICustomerConfiguration>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ICustomerConfiguration>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: ICustomerConfigurationInput): Promise<void> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async getById(configurationId: number): Promise<ICustomerConfiguration> {
    const response = await httpRequest.get(`${this.baseUrl}/${configurationId}`);
    return response;
  }

  async update(formData: ICustomerConfigurationInput, configurationId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${configurationId}`, {
      freightType: formData.freightType,
      daysUntilDue: Number(formData.daysUntilDue),
      paymentReminderInterval: Number(formData.paymentReminderInterval),
      paymentReminderTimes: Number(formData.paymentReminderTimes),
      unitDeliveryTime: formData.unitDeliveryTime,
      freightOverhead: Number(formData.freightOverhead ?? 0),
      freightOverheadType: formData.freightOverheadType || FreightOverheadType.Monetary,
      consentRequest: formData.consentRequest,
      consentExpiration: formData.consentExpiration,
      consentCancel: formData.consentCancel,
    });
  }

  async delete(configurationId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${configurationId}`);
  }
}

const customerConfigurationService = new CustomerConfigurationService();
export default customerConfigurationService;
